import * as React from 'react';
import { Space, Tabs } from 'antd';
import './index.scss';
import CustomRoutes from '../Routes/CustomRoutes';
import { useLocation, useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;
export interface tabsProps {
    key: string; label: string | React.ReactNode; content: any
}

interface CustomTabsProps {
    tabs: tabsProps[];
    defaultActiveKey?: string;
    onTabChange?: (activeKey: string) => void;
    routes?: boolean;
}

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, defaultActiveKey, onTabChange, routes }) => {
    const [activeKey, setActiveKey] = React.useState(null);
    const navigate = useNavigate();
    const locations = useLocation();
    const [activeRoute] = React.useState<string>(locations.pathname);

    React.useEffect(() => {
        setActiveKey(defaultActiveKey);
        onTabChange(defaultActiveKey);
    }, [defaultActiveKey]);

    const handleTabChange = (activeKey: string) => {
        setActiveKey(activeKey);
        if (onTabChange) {
            onTabChange(activeKey);
        }
        if (routes) {
            navigate(`${activeRoute}/${activeKey}`, { replace: true });
        }
    }

    return (
        <Space direction='vertical' style={{ width: '100%' }}>
            <Tabs className='tabs_bg' activeKey={activeKey} onChange={handleTabChange}>
                {tabs.map((tab) => (
                    <TabPane tab={tab.label} key={tab.key}>
                    </TabPane>
                ))}
            </Tabs>
            {routes && <CustomRoutes routes={tabs} />}
        </Space>
    );
};

export default CustomTabs;
